// Agent-authored HTML boxes (id contains "-agt-") render as srcdoc iframes with a
// stricter CSP and a navigation guard. Shared by VisorBox, EditorBox, RemotionComposition.
const LEGACY_CSP =
  "default-src 'self' 'unsafe-inline'; connect-src 'none'; img-src * data:; media-src *";
export const agentHtmlCsp =
  "default-src 'none'; script-src 'unsafe-inline'; style-src 'unsafe-inline'; img-src data: blob:; media-src data: blob:; font-src data:; connect-src 'none'; frame-src 'none'; form-action 'none'; base-uri 'none'";
const MAX_RESETS = 3;

export const isAgentHtmlBox = (id) => typeof id === "string" && id.includes("-agt-");

// Returns the HTML with the CSP meta always prepended (injecting after <head> or after a doctype
// was bypassable by parser differentials). Cost: agent HTML renders in quirks mode (MW renderer does the same).
// Agent boxes also get a base style (no margin/scrollbars, svg fits the box); author CSS still wins.
export const agentBaseStyle =
  "<style>html,body{margin:0;overflow:hidden}svg{max-width:100%;max-height:100%}</style>";
export const withHtmlCsp = (id, html) =>
  `<meta http-equiv="Content-Security-Policy" content="${isAgentHtmlBox(id) ? agentHtmlCsp : LEGACY_CSP}">` +
  (isAgentHtmlBox(id) ? agentBaseStyle : "") +
  html;

// ponytail: known gap -- the guard runs after load, so a navigation can fire a beacon before
// the reset, and there is no `navigate-to` CSP. Mitigated by the sandbox lacking
// allow-same-origin (opaque origin, no cookies/storage) + connect-src 'none'.
const states = new WeakMap();

// iframe onLoad handler for agent boxes (undefined for others). The first load is the
// srcdoc itself; a later load means the content navigated away -> restore srcdoc, and
// after MAX_RESETS blank it. Our own reset's load event is skipped.
export const agentNavGuard = (id, srcDoc) => {
  if (!isAgentHtmlBox(id)) return undefined;
  return (e) => {
    const el = e.currentTarget || e.target;
    let s = states.get(el);
    if (!s || s.src !== srcDoc) {
      s = { src: srcDoc, loads: 0, resets: 0, skip: false };
      states.set(el, s);
    }
    if (s.skip) {
      s.skip = false;
      return;
    }
    if (++s.loads < 2) return;
    s.skip = true;
    el.srcdoc = ++s.resets <= MAX_RESETS ? srcDoc : "";
  };
};
